import { isImageEditableURL } from 'utils/assets';
import { postGallery } from 'admin/actions/story/gallery';
import { useAdminDispatch, useAdminSelector } from 'admin/reducers';
import { selectEditableStoryId, selectStorycardsDomain } from 'admin/reducers/story-editor/selectors';
import { setImageSize } from '../utils/set-image-size';
import type { InspectorTypes } from '../types';

type MediaUpload = NonNullable<ReturnType<InspectorTypes.GetFieldListeners>['onUpload']>;

/**
 * The media field's upload for a value outside the card form, such as a background layer or a design asset: uploads a
 * file, or sizes a URL on our hosting, without writing any field. The media field then writes the result.
 */
export function useMediaUpload(): MediaUpload {
	const dispatch = useAdminDispatch();
	const storyId = useAdminSelector(selectEditableStoryId);
	const storycardsDomain = useAdminSelector(selectStorycardsDomain);
	return async ({ asset }) => {
		if (typeof asset !== 'string') {
			const response = await dispatch(postGallery({ asset, storyId: storyId ?? '' }));
			const uploaded = response.result?.asset ?? '';
			return { asset: uploaded ? await setImageSize(uploaded, storycardsDomain) : '' };
		}
		if (asset && isImageEditableURL(asset, storycardsDomain))
			return { asset: await setImageSize(asset, storycardsDomain) };
		return { asset };
	};
}
